import { render } from "./ChangeDepartmentModal.vue?vue&type=template&id=32de188d&ts=true"
import script from "./ChangeDepartmentModal.vue?vue&type=script&lang=ts"
export * from "./ChangeDepartmentModal.vue?vue&type=script&lang=ts"

import "./ChangeDepartmentModal.vue?vue&type=style&index=0&id=32de188d&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__